var map = {
	"./+class.png": 8169,
	"./10-mobile-task-portrait.png": 9494,
	"./11-mobile-task-landscape.png": 7213,
	"./2-tips-for-doing-PA-task.png": 8471,
	"./3-vocab-mem-areas.png": 6670,
	"./8-burger-menu-off.png": 9360,
	"./9-burger-menu-on.png": 7451,
	"./FS ~ meaning.png": 6286,
	"./FS-level-low.png": 7333,
	"./SB-task-WLRS-scheme.png": 262,
	"./certificate-100.png": 8225,
	"./certificate-32.png": 361,
	"./certificate-64.png": 1800,
	"./chen-jiajie-wxid-qr-code-small.png": 6860,
	"./classes.png": 514,
	"./five-star-word-w-5com.png": 9505,
	"./fsv-round.png": 1168,
	"./language-icon.svg": 2664,
	"./level.png": 7360,
	"./sbtext.png": 7602,
	"./selectClass-1.png": 6720,
	"./selectClass.png": 8226,
	"./signup-default.png": 9604,
	"./signup-demot.png": 5736,
	"./signup-simplified-Chinese.png": 2995,
	"./spellingbee.jpg": 2752,
	"./standards.png": 9988,
	"./tasks-demos.png": 9843,
	"./textbooks.png": 5079,
	"./top-10.svg": 5057,
	"./user-guide-icon.svg": 1944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6193;